---@meta

---@class Bot
---@field say fun(self: Bot, message: string)
---@field reply fun(self: Bot, message: string, replyId: string)
---@field announceGreen fun(self: Bot, message: string): string
---@field announceBlue fun(self: Bot, message: string): string
---@field announceOrange fun(self: Bot, message: string): string
---@field announcePurple fun(self: Bot, message: string): string
---@field deleteMessage fun(self: Bot, messageId: string): string
---@field clearChat fun(self: Bot): string
---@field getChannelInformationByChannelName fun(self: Bot, channelName: string): ChannelInformation, string
---@field getUserDisplaynameByUserID fun(self: Bot, userId: string): string, string
---@field getUserIDByUsername fun(self: Bot, userName: string): string, string
---@field shoutOut fun(self: Bot, userName: string): string
---@field banUser fun(self: Bot, userName: string, reason: string, durationInSeconds: number): string
---@field getStreamState fun(self: Bot): StreamState

bot = {} ---@type Bot
